module.exports = __webpack_public_path__ + "f6610c95497c50c68b1ccb71de4aef34.jpg";